export default {
  title: 'Tilauksen tiedot',
};
